const _import = require('../import-' + process.env.NODE_ENV)

const wmsDataRouter = [
  {
    path: '/wmsData/electronicOrder',
    name: 'wmsDataElectronicOrder',
    component: _import('wmsData/electronicOrder'),
    meta: {
      title: '配送单明细',
      auth: true
    }
  },
  {
    path: '/wmsData/warnList',
    name: 'wmsDataWarnList',
    component: _import('wmsData/warnList'),
    meta: {
      title: '仓库商品提醒',
      auth: true
    }
  }
]
export default wmsDataRouter



// WEBPACK FOOTER //
// ./src/router/work/wmsData.js